import { getClubId } from "src/api/CalendarBooking";
import { isFlowAccountTaxDocumentClub } from "./flowaccountClubs";

/**
 * Open the tax documents dialog from anywhere (POS sale, membership sale),
 * even after the screen that took the payment has closed. The dialog lives in
 * `FlowAccountTaxDocumentsHost`, mounted once at the app root.
 */
export const TAX_DOCUMENTS_EVENT = "bag:flowaccount-tax-documents";

export type TaxDocumentSale =
  | { service_booking_id: number }
  | { pos_payment_ids: number[] }
  | { transaction_id: number | null | undefined };

export interface TaxDocumentsRequest {
  locationId: number;
  sale: TaxDocumentSale;
}

const hasSale = (sale: TaxDocumentSale): boolean => {
  if ("service_booking_id" in sale) return Number(sale.service_booking_id) > 0;
  if ("pos_payment_ids" in sale) return Array.isArray(sale.pos_payment_ids) && sale.pos_payment_ids.length > 0;
  return Number(sale.transaction_id) > 0;
};

/** No-op for every club without FlowAccount tax documents. */
export const openTaxDocuments = (request: TaxDocumentsRequest): void => {
  if (!isFlowAccountTaxDocumentClub(getClubId())) return;
  if (!(Number(request?.locationId) > 0) || !request?.sale || !hasSale(request.sale)) return;
  window.dispatchEvent(new CustomEvent(TAX_DOCUMENTS_EVENT, { detail: request }));
};
